import styles from './PillTabsModule.module.scss';

import cx from 'classnames';
import React, { FC } from 'react';

import { PillTabs } from 'api/contentful/contentTypes.cloverdotcom';
import { FadeToastUp } from 'components/Animation/FadeToastUp/FadeToastUp';
import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { FlatResponsiveImage } from 'components/FlatResponsiveImage/FlatResponsiveImage';
import { TextV2 } from 'components/TextV2/TextV2';
import { useLocation } from 'react-router';
import { FlatEntry } from 'services/cms/flattenContentful';
import { AppType, toEntry, toSysId } from 'services/cms/typesUtil';

type PillTabsModuleProps = AppType.Component<FlatEntry<PillTabs>>;

export const PillTabsModule: FC<PillTabsModuleProps> = ({ title, items = [], link, _attributes }) => {
  const { pathname } = useLocation();
  const navId = `nav${_attributes?.['data-entry-id']}`;
  return (
    <section className={styles.root} {..._attributes}>
      <FadeToastUp>
        <nav className={styles.nav} aria-labelledby={navId}>
          <TextV2 tagName="h2" id={navId} value={title} className={styles.title} variant="modern-eyebrow" />
          <ul className={styles.list}>
            {items.map(item => {
              if (!item) return null;
              const isActive = item.url === pathname;
              return (
                <li key={toSysId(item)} className={styles.listItem}>
                  <ContentLinkV2
                    entry={toEntry(item)}
                    hideTitle
                    className={cx(styles.tab, isActive && styles.active)}
                  >
                    {item.image && item.customIcon && (
                      <span className={styles.icon}>
                        <FlatResponsiveImage image={item.image} className={styles.iconImage} />
                        <FlatResponsiveImage image={item.customIcon} className={styles.iconImageActive} />
                      </span>
                    )}
                    <TextV2 value={item.title} variant="modern-button-text" />
                  </ContentLinkV2>
                </li>
              );
            })}
          </ul>
          <ContentLinkV2 entry={toEntry(link)} hideTitle className={styles.link}>
            <TextV2 value={link?.title} variant="modern-button-text" />
          </ContentLinkV2>
        </nav>
      </FadeToastUp>
    </section>
  );
};
